import routes from "./evaluationRoutes";
import miniRoutes from "./miniEvaluationRoutes";

import CommonDataService from "../../services/commonDataService";
import CurriculumService from "./services/curriculumService";
import EvaluationService from "./services/evaluationService";
import GradeService from "./services/gradeService";
import LearningAreaService from "./services/learningAreaService";
import PipeDriveService from "./services/pipeDriveService";
import StepMiniPedagogicalApproachService from "./pages/stepMiniPedagogicalApproach/services/stepMiniPedagogicalApproachService";
import SubjectAreaService from "./services/subjectAreaService";
import UserService from "../user/services/userService";
import PedagogicalService from "../manageSkills/services/pedagogicalService";

import EvaluationComponent from "./evaluationComponent";
import StatusbarComponent from "./statusbar/statusbarComponent";
import StepsListComponent from "./stepsList/stepsListComponent";
import StepBasicInfoComponent from "./pages/stepBasicInfo/stepBasicInfoComponent";
import stepLearningGoals from "./pages/stepLearningGoals";
import stepLearningEngagement from "./pages/stepLearningEngagement";
import stepPedagogicalApproach from "./pages/stepPedagogicalApproach";
import stepConclusions from "./pages/stepConclusions";
import StepGDPRComponent from "./pages/stepGDPR/stepGDPRComponent";
import StepPublishComponent from "./pages/stepPublish/stepPublishComponent";
import evaluationNotes from "./components/notes/evaluationNotesComponent";
import TabsListComponent from "./components/areasNavigation/areasNavigationComponent";
import stepMiniPedagogicalApproachComponent from "./pages/stepMiniPedagogicalApproach/stepMiniPedagogicalApproachComponent";
import ParameterListComponent from "./pages/stepLearningGoals/parametersList/parameterListComponent";
import PedagogicalApproachParameterComponent from "./pages/stepMiniPedagogicalApproach/singleParameterView/pedagogicalApproachParameterComponent";

const EvaluationModule = angular
    .module("app.evaluation", [
        stepLearningGoals.name,
        stepLearningEngagement.name,
        stepPedagogicalApproach.name,
        stepConclusions.name,
    ])
    .config(routes)
    .config(miniRoutes)
    .component("evaluation", EvaluationComponent)
    .component("statusbar", StatusbarComponent)
    .component("stepsList", StepsListComponent)
    .component("stepBasicInfo", StepBasicInfoComponent)
    .component("stepGdpr", StepGDPRComponent)
    .component("stepPublish", StepPublishComponent)
    .component("evaluationNotes", evaluationNotes)
    .component("tabsList", TabsListComponent)
    .component("parameterList", ParameterListComponent)
    .component("miniPedagogicalApproach", stepMiniPedagogicalApproachComponent)
    .component("singleParameter", PedagogicalApproachParameterComponent)
    .service("CommonDataService", CommonDataService)
    .service("CurriculumService", CurriculumService)
    .service("EvaluationService", EvaluationService)
    .service("GradeService", GradeService)
    .service("LearningAreaService", LearningAreaService)
    .service("PipeDriveService", PipeDriveService)
    .service("PedagogicalService", PedagogicalService)
    .service(
        "StepMiniPedagogicalApproachService",
        StepMiniPedagogicalApproachService
    )
    .service("SubjectAreaService", SubjectAreaService)
    .service("UserService", UserService);

export default EvaluationModule;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/index.js